import React from 'react';
import { E_FATURA_GUIDES_LINK, E_FATURA_LINK } from '../../../../constants';
import Icon from '../../../atoms/icons/Icon';
import Span from '../../../atoms/spans/Span';

export const AtCommunicationHelper = {
  /**
   * Creates the history configuration object for the AT Communication history table
   * @param {Object} intl - The intl object from react-intl
   * @returns {Object} The history configuration object
   */
  createHistoryConfig: (intl) => {
    return {
      sequence_number: {
        headerClassName: 'col-5 col-md-2',
        headerValue:
          intl.messages['atCommunicationHistoryHeader_SequenceNumber'],
        rowClassName: 'col-5 col-md-2 font-bold color-gray-500',
      },
      request_sent_at: {
        headerClassName: 'd-none d-xs-flex d-md-flex col-5 col-md-2',
        headerValue: intl.messages['atCommunicationHistoryHeader_RequestDate'],
        rowClassName:
          'col-5 col-md-2 color-gray-500 d-none d-xs-flex d-md-flex',
        formatValue: (date) => {
          if (!date) {
            return '--/--/--';
          } else {
            try {
              return new Intl.DateTimeFormat('pt-PT', {
                timeZone: 'Europe/Lisbon',
              }).format(new Date(date));
            } catch (e) {
              return '--/--/--';
            }
          }
        },
      },
      document_type: {
        headerClassName: 'd-none d-md-flex col-5 col-md-2',
        headerValue: intl.messages['atCommunicationHistoryHeader_DocumentType'],
        rowClassName: 'col-5 col-md-2 color-gray-500 d-none d-md-flex',
      },
      communication_status: {
        headerClassName: 'd-none d-md-flex col-5 col-md-2',
        headerValue: intl.messages['atCommunicationHistoryHeader_Status'],
        rowClassName: 'col-5 col-md-2 color-gray-500 d-none d-md-flex',
      },
      response_message: {
        headerClassName: 'col-5 col-md-2',
        headerValue:
          intl.messages['atCommunicationHistoryHeader_ResponseMessage'],
        rowClassName: 'col-5 col-md-2 color-gray-500',
        formatValue: (value) => {
          if (!value) {
            // Return a format that can be easily tested and rendered by the component
            return (
              <Span>
                <Icon className='fas fa-hourglass' id='icon'></Icon>
              </Span>
            );
          }
          return value;
        },
        paragraphClassName: (element) =>
          element.response_code !== 0
            ? 'text-paragraph-error font-bold'
            : 'text-paragraph',
      },
    };
  },

  /**
   * Creates the history actions object for the AT Communication history table
   * @returns {Object} The history actions object
   */
  createHistoryActions: () => {
    return {
      clickable: false,
    };
  },

  /**
   * Creates the messages keys object for the AT Communication layout
   * @returns {Object} The messages keys object
   */
  getMessagesKeys: () => {
    return {
      auto: {
        title: 'atCommunicationActiveAutoTitle',
        description: 'atCommunicationActiveAutoDescription',
        billingDocumentsDescription: 'atCommunicationMethodAutoDescription',
        transportDocumentsDescription: 'atCommunicationMethodAutoDescription',
      },
      guides: {
        title: 'atCommunicationActiveGuidesOnlyTitle',
        description: 'atCommunicationActiveGuidesOnlyDescription',
        billingDocumentsDescription:
          'atCommunicationMethodManualDescription1Anchor',
        transportDocumentsDescription: 'atCommunicationMethodAutoDescription',
      },
      manual: {
        title: 'atCommunicationActiveManualTitle',
        description: 'atCommunicationActiveManualDescription',
        billingDocumentsDescription:
          'atCommunicationMethodManualDescription1Anchor',
        transportDocumentsDescription:
          'atCommunicationMethodManualDescription2Anchor',
      },
    };
  },

  /**
   * Gets the links for the AT Communication layout
   * @returns {Object} The links object
   */
  getLinks: () => {
    return {
      E_FATURA_LINK,
      E_FATURA_GUIDES_LINK,
    };
  },
};
